import { Component } from '@angular/core';

@Component({
  host: { 'test-id': 'user-sync-error' },
  selector: 'user-sync-error',
  template: `
    <fw-layout-context
      title="User Sync Error"
      description="Your user information couldn't sync to the login system. It might take 1-2 minutes for new or updated user data to sync completely. Please wait a moment, then try logging in again. If the issue continues, reach out to support for help."
      icon="rotate-refresh"
      iconColor="secondary"
    >
      <fw-button (click)="retry()" variant="outline" leftIcon="rotate-refresh" size="large">Retry</fw-button>
    </fw-layout-context>
  `,
  styles: [
    `
      :host {
        width: 100vw;
        height: 100vh;
        background: var(--page-light);
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
      }
    `,
  ],
  standalone: false,
})
export class UserSyncErrorComponent {
  retry(): void {
    location.reload();
  }
}
